import { AppTreeSide, UniDateRangePicker } from 'components'
import ShowAlarmEvent from '../../common/showAlarmEvent'
import ssoLoginMixin from '@/mixins/sso-login-mixin.js' // 引入mixin文件
import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件
import idNameMixin from '@/mixins/id-name-mixin.js' // 引入mixin文件
import typeImageMixin from '@/mixins/type-image-mixin.js' // 引入mixin文件
import {getRegionList} from '@/api/get-data.js'
import {loadRegionTree} from '@/utils/tree'
import {getTodayBeginAndEndDate, getOneWeekBeginAndEndDate} from '@/utils/date'

export default {
  name: 'ParkingManagement',
  data () {
    return {
      // 侧边栏打开标志
      treeSideBarOpen: true,
      // 底部栏打开标志
      footerOpen: true,
      // 树数据
      treeData: [],
      treeExpandedKeys: [], // 默认展开树节点key
      // 树查询条件
      treeQueryParams: {
        pageNum: 1,
        pageSize: 1000
      },
      // 默认树属性
      defaultTreeProps: {
        label: 'name' // name字段作为label
      },
      // 树节点显示过滤
      treeNodeFilter: '',
      filteredTreeData: [],
      // 活动页面索引
      activeTabName: '0',
      // 遮罩层
      loading: false,
      // 道闸列表页面--------------------------------------------------------------------------------------------------
      // 卡片数据
      cardData: [], //
      cardTotalItem: 0, // 记录总数
      cardMaxRowCount: 2, // 当前页卡片最大行数
      cardMaxColCount: 4, // 当前页卡片最大列数
      cardRowCount: 0, // 当前页卡片实际行数
      cardColCountPerRows: [], // 当前页卡片每行列数
      // 卡片查询条件
      cardQueryParams: {
        regionId: -1,
        nodeId: 0,
        descendantRegionRequired: 1,
        resourceKind: 22,
        gaugedObjectKind: 50, // 道闸
        alarmStates: [],
        // systemKind: this.systemKind,
        encoderStateRequired: 1, // 要求返回监控设备状态
        pageNum: 1,
        pageSize: 8
      },
      pageTotalCount: 0,
      pageNormalCount: 0,
      pageAlarmCount: 0,
      pageErrorCount: 0,
      // 卡片当前项
      cardCurrentItem: null,
      // 数据节点信息弹窗
      showDataNodeModalOpen: false,
      // 实时事件
      // 表格数据
      realEventTableData: [],
      realEventTableTotalRow: 0,
      // 表格查询条件
      realEventDates: [], // 查询起始和结束日期
      realEventTableQueryParams: {
        lastEventId: 0,
        regionId: 0,
        descendantRegionRequired: 1,
        objectId: 0,
        resourceKind: 22,
        resourceSubType: 50, // 道闸
        // systemKind: this.systemKind, // 系统种类
        alarmStates: [],
        beginHappenDateTime: 0,
        endHappenDateTime: 0,
        handleStates: [], // 处理状态数组
        orderBy: 1, // 排序方式,0-增序，1-减序
        pageNum: 1,
        pageSize: 3
      },
      // 事件表格当前行
      realEventTableCurrentRow: null,
      // 事件信息弹窗
      showRealEventModalOpen: false,
      // 历史事件页面--------------------------------------------------------------------------------------------------
      diDirectionsIncludeAll: [], // 进出方向数组
      // 表格数据
      historyEventTableData: [],
      historyEventTableTotalRow: 0,
      // 表格查询条件
      historyEventDates: [], // 查询起始和结束日期
      historyEventTableQueryParams: {
        lastEventId: 0,
        regionId: 0,
        objectId: 0,
        descendantRegionRequired: 1,
        resourceKind: 22,
        resourceSubType: 50, // 道闸
        // systemKind: this.systemKind, // 系统种类
        alarmStates: [],
        beginHappenDateTime: 0,
        endHappenDateTime: 0,
        handleStates: [], // 处理状态数组
        personName: '', // 车主
        licenseNumber: '', // 车牌号
        departmentName: '', // 部门名称
        direction: 255, // 进出方向
        orderBy: 1, // 排序方式,0-增序，1-减序
        pageNum: 1,
        pageSize: 15
      },
      // 表格选中记录数组
      historyEventTableSelectedIds: [],
      // 事件表格当前行
      historyEventTableCurrentRow: null,
      // 事件信息弹窗
      showHistoryEventModalOpen: false,
      // 轮巡定时器
      pollingTimer: null
    }
  },
  props: {
    systemKind: {
      type: Number,
      default() {
        return 3106 // 停车场管理
      }
    }
  },
  components: {
    AppTreeSide,
    UniDateRangePicker,
    ShowAlarmEvent
  },
  mixins: [
    ssoLoginMixin,
    convertorMixin,
    idNameMixin,
    typeImageMixin
  ],
  watch: {
    // 根据名称筛选节点
    treeNodeFilter(val) {
      this.$refs.tree.filter(val.trim())
    }
  },
  created() {
    // 显示或隐藏树侧边栏
    this.treeSideBarOpen = this.$globalConfig.treeSideBarOpen
    if (this.$route.query.treeSideBarOpen) {
      this.treeSideBarOpen = this.$route.query.treeSideBarOpen === '1' || this.$route.query.treeSideBarOpen === 'true'
    }
  },
  mounted () {
    // 设置查询起始日期和截止日期
    this.realEventDates = getTodayBeginAndEndDate() // 今天
    this.historyEventDates = getOneWeekBeginAndEndDate() // 近一周

    //
    this.diDirectionsIncludeAll = [{id: 255, name: '全部'}] // 插入‘全部’选项
    this.diDirectionsIncludeAll.push(...this.$type.diDirections)

    // 根据浏览器高度设置卡片最大行数
    this.cardMaxRowCount = window.innerHeight < 950 ? 1 : 2
    // 根据卡片最大行数和最大列数返回页数
    this.cardQueryParams.pageSize = this.cardMaxRowCount * this.cardMaxColCount

    // 开始定期检测尺寸大小改变
    this.reizeTimer = setInterval(() => {
      this.handleCardContainerResize()
    }, this.$globalConfig.resizeInterval)

    // 单点登录（如url包含code和uiapTpye参数则启用单点登录）
    this.ssoLogin(this.$route.query.code, this.$route.query.uiapType).then(res => {
      // 获取区域列表
      this.getRegionList2()

      // 开始数据轮巡
      this.startDataPolling()
    })
  },
  beforeDestroy() {
    // 停止数据轮巡
    this.stopDataPolling()

    // 停止定期检测尺寸大小改变
    if (this.reizeTimer != null) {
      clearInterval(this.reizeTimer)
      this.reizeTimer = null
    }
  },
  methods: {
    // 显示或隐藏树侧边栏
    toggleTreeSideBar() {
      this.treeSideBarOpen = !this.treeSideBarOpen
    },
    toggleFooter() {
      this.footerOpen = !this.footerOpen
    },
    // 查询区域列表
    getRegionList2() {
      this.loading = true
      getRegionList(this.$globalConfig.regionGettingFilterMode, () => {
        this.loading = false
        this.treeData = []
        this.treeData = loadRegionTree(this.$globalData.regions, this.treeData)
        this.$nextTick(() => {
          if (this.treeData.length) {
            // 默认展开根节点
            this.treeExpandedKeys = [this.treeData[0].key]
            // 设置根节点或根节点的首个子节点为当前节点
            let currentKey = null
            if (this.$globalConfig.currentRegionSynchEnabled && this.$store.getters.appCurrentRegionKey) { // 当前区域同步启用
              currentKey = this.$store.getters.appCurrentRegionKey
            } else {
              if (this.$globalConfig.defaultCurrentTreeNode === 0) { // 根节点
                currentKey = this.treeData[0].key
              } else if (this.$globalConfig.defaultCurrentTreeNode === 1) { // 根节点的首个子节点
                currentKey = this.treeData[0].children.length > 0 ? this.treeData[0].children[0].key : this.treeData[0].key
              }
            }
            if (currentKey) {
              this.$refs.tree.setCurrentKey(currentKey)
              // 单击当前节点
              this.handleTreeNodeClick(this.$refs.tree.getCurrentNode())
            }
            // 只有一个树节点自动隐藏侧边栏
            if (this.treeData[0].children.length === 0) {
              this.treeSideBarOpen = false
            }
          }
        })
      })
    },
    // 查询数据节点列表
    getDataNodeList() {
      this.loading = true
      this.$http(this.$api.dataNodeList, this.cardQueryParams).then(
        res => {
          if (res.code === 200) {
            // 获取最早事件发生时间
            let theOldestHappenTime = new Date().getTime()
            res.data.forEach(item => {
              if (item.happenTime * 1000 < theOldestHappenTime) {
                theOldestHappenTime = item.happenTime * 1000
              }
              item.licenseNumber = '无车辆'
              item.vehicleKind = 0
              item.pictureUrl = ''
              item.letPass = 0
            })

            this.cardData = res.data
            this.cardTotalItem = res.page.totalRow
            // 计算卡片行数
            this.cardRowCount = Math.ceil(this.cardData.length / this.cardMaxColCount) // 向上取整
            // 计算卡片每行列数
            this.cardColCountPerRows = []
            for (let i = 0; i < this.cardRowCount; ++i) {
              this.cardColCountPerRows[i] = (this.cardData.length - this.cardMaxColCount * i) / this.cardMaxColCount >= 1 ? this.cardMaxColCount : (this.cardData.length - this.cardMaxColCount * i) % this.cardMaxColCount
              this.cardColCountPerRows[i] = Math.abs(this.cardColCountPerRows[i]) // 余数可能为负，需取绝对值
            }

            if (res.data.length) {
              if (this.cardCurrentItem === null) {
                this.cardCurrentItem = res.data[0] // 选中首项
              } else {
                this.cardCurrentItem = this.getRecordById(this.cardCurrentItem.id, res.data)
                if (this.cardCurrentItem === null) { // 数组是否包含选中项
                  this.cardCurrentItem = res.data[0] // 选中首项
                }
              }
            }
            // 统计当前页面节点数量
            this.statPageDataNodeCount()

            // 继续返回最近事件，更新对应数据节点状态
            let historyEventTableQueryParams = []
            Object.assign(historyEventTableQueryParams, this.historyEventTableQueryParams) // 数组复制
            historyEventTableQueryParams.regionId = this.cardQueryParams.regionId
            historyEventTableQueryParams.objectId = 0
            historyEventTableQueryParams.descendantRegionRequired = 1
            historyEventTableQueryParams.alarmStates = []
            historyEventTableQueryParams.beginHappenDateTime = theOldestHappenTime / 1000
            historyEventTableQueryParams.endHappenDateTime = new Date().getTime() / 1000
            this.historyEventTableQueryParams.handleStates = []
            historyEventTableQueryParams.orderBy = 1
            historyEventTableQueryParams.pageNum = 1
            historyEventTableQueryParams.pageSize = 1000
            this.$http(this.$api.historyEventList, historyEventTableQueryParams).then(
              res => {
                if (res.code === 200) {
                  // 根据事件列表更新节点列表状态
                  this.updateDataNodeListByEventList(res.data)
                }
              }).catch(err => {
              console.log(err)
            })
          }
          this.loading = false
        }
      ).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 查询实时事件列表
    getRealEventList() {
      if (this.realEventTableQueryParams.lastEventId > 0 &&
        this.realEventTableQueryParams.lastEventId >= this.$store.getters.appLastEventId) { // 检测是否有新事件
        return
      }
      this.realEventTableQueryParams.lastEventId = this.$store.getters.appLastEventId // 更新最后事件id

      this.loading = true
      // 根据查询条件过滤实时事件数组
      let events = this.filterRealEvents()
      // 根据页面序号和大小返回实时事件数组起始和结束索引
      let beginIndex = (this.realEventTableQueryParams.pageNum - 1) * this.realEventTableQueryParams.pageSize
      let endIndex = this.realEventTableQueryParams.pageNum * this.realEventTableQueryParams.pageSize - 1
      if (endIndex > events.length - 1) {
        endIndex = events.length - 1
      }
      this.realEventTableData = []
      for (let i = beginIndex; i <= endIndex; ++i) {
        this.realEventTableData.push(events[i])
      }
      this.realEventTableTotalRow = events.length
      this.loading = false

      // 根据事件列表更新节点列表状态
      this.updateDataNodeListByEventList(events)
    },
    // 过滤实时事件数组
    filterRealEvents() {
      let filteredEvents = []
      let event = null
      for (let i = 0; i < this.$store.getters.appNewEvents.length; ++i) {
        event = this.$store.getters.appNewEvents[i]
        if (event.resourceKind !== 22 || event.resourceSubType !== 50) {
          continue
        }
        filteredEvents.unshift(event) // 倒序插入
      }
      return filteredEvents
    },
    // 查询历史事件列表
    getHistoryEventList() {
      this.loading = true
      this.historyEventTableQueryParams.beginHappenDateTime = this.historyEventDates[0].getTime() / 1000
      this.historyEventTableQueryParams.endHappenDateTime = this.historyEventDates[1].getTime() / 1000
      this.$http(this.$api.historyEventList, this.historyEventTableQueryParams).then(
        res => {
          if (res.code === 200) {
            this.historyEventTableData = res.data
            this.historyEventTableTotalRow = res.page.totalRow
          }
          this.loading = false
        }
      ).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 根据事件列表更新节点列表状态
    updateDataNodeListByEventList(evnets) {
      let dataNodeIds = []
      for (let i = 0; i < evnets.length; ++i) { // 遍历全部事件
        let item = evnets[i]
        if (dataNodeIds.indexOf(item.resourceId) !== -1) {
          continue
        }
        for (let j = 0; j < this.cardData.length; ++j) { // 遍历数据节点
          if (this.cardData[j].id === item.resourceId) {
            this.cardData[j].licenseNumber = item.licenseNumber
            this.cardData[j].vehicleKind = item.vehicleKind
            this.cardData[j].happenTime = item.happenTime
            if (item.pictureType1 >= 101 && !item.pictureUrl1.length !== 0) {
              this.cardData[j].pictureUrl = item.pictureUrl1
            } else if (item.pictureType2 >= 101 && !item.pictureUrl2 !== 0) {
              this.cardData[j].pictureUrl = item.pictureUrl2
            }
            this.cardData[j].letPass = item.letPass
            dataNodeIds.push(item.resourceId)
            break
          }
        }
        if (dataNodeIds.length === this.cardData.length) { // 全部节点已遍历，终止更新
          break
        }
      }
    },
    // 统计当前页面节点数量
    statPageDataNodeCount() {
      this.pageTotalCount = 0
      this.pageNormalCount = 0
      this.pageAlarmCount = 0
      this.pageErrorCount = 0
      if (this.cardTotalItem === 0) {
        return
      }

      this.cardData.forEach(item => {
        ++this.pageTotalCount
        if (item.alarmState === 0) {
          ++this.pageNormalCount
        } else if (item.alarmState === 1) {
          if (item.resourceKind === 22) {
            if (item.eventTypeSet === 0x04) {
              ++this.pageErrorCount
            } else {
              ++this.pageAlarmCount
            }
          } if (item.resourceKind === 23) {
            if (item.eventTypeSet === 0x20) {
              ++this.pageErrorCount
            } else {
              ++this.pageAlarmCount
            }
          }
        }
      })
    },
    // 开始数据轮巡
    startDataPolling() {
      this.pollingTimer = setInterval(() => {
        if (this.loading) { // 检测上一次查询是否尚未结束
          return
        }
        if (this.activeTabName === '0') {
          if (this.showDataNodeModalOpen) { // 暂停刷新数据
            return
          }
          this.getRealEventList()
        } else if (this.activeTabName === '1') {
        }
      }, this.$globalConfig.pagePollingInterval)
    },
    // 停止数据轮巡
    stopDataPolling() {
      if (this.pollingTimer != null) {
        clearInterval(this.pollingTimer)
        this.pollingTimer = null
      }
    },
    // 过滤树节点
    filterTreeNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 单击树节点
    handleTreeNodeClick(obj) {
      if (this.activeTabName === '0') {
        if (this.cardQueryParams.regionId !== obj.id) {
          this.cardQueryParams.regionId = obj.id
          this.cardQueryParams.pageNum = 1
          this.getDataNodeList()
          this.getRealEventList()
        }
      } else if (this.activeTabName === '1') {
        if (this.historyEventTableQueryParams.regionId !== obj.id) {
          this.historyEventTableQueryParams.regionId = obj.id
          this.historyEventTableQueryParams.pageNum = 1
          this.getHistoryEventList()
        }
      }
      if (this.$globalConfig.currentRegionSynchEnabled) { // 当前区域同步启用
        this.$store.commit('app/SET_CURRENT_REGION_KEY', obj.key) // 更新当前区域key
      }
    },
    // tab页面切换
    handleTabClick(tab) {
      let currentNode = this.$refs.tree.getCurrentNode()
      if (currentNode) {
        this.handleTreeNodeClick(currentNode)
      }
    },
    // 道闸列表页面------------------------------------------------------------------------------------------------
    // 处理卡片容器大小改变
    handleCardContainerResize() {
      // 由于realEventContianer元素采用fixed定位方式，因此100%为文档元素的宽度，会导致表格元素水平方向过宽而显示不完整
      // 比较两者宽度，不一致则进行同步
      if (this.$refs.realEventContianer.$el.scrollWidth !== this.$refs.cardContianer.scrollWidth) {
        this.$refs.realEventContianer.$el.style.width = this.$refs.cardContianer.clientWidth + 'px'
        console.log('realEventContianer width is different from cardContianer')
      }
    },
    // 查询按钮操作
    handleFormQuery() {
      this.cardQueryParams.pageNum = 1
      this.getDataNodeList()
    },
    // 重置按钮操作
    resetQueryForm() {
      this.cardQueryParams.regionId = 0
      this.cardQueryParams.nodeId = 0
      this.cardQueryParams.descendantRegionRequired = 1
      this.cardQueryParams.resourceKind = 22
      this.cardQueryParams.gaugedObjectKind = 50
      this.cardQueryParams.alarmStates = []
      this.cardQueryParams.pageNum = 1
      this.$refs['queryForm'].resetFields()
      this.handleFormQuery()
    },
    // 分页
    handleCurrentPageChange(val) {
      this.cardQueryParams.pageNum = val
      this.getDataNodeList()
    },
    // 页面条数改变
    handlePageSizeChange(val) {
      this.cardQueryParams.pageSize = val
      this.getDataNodeList()
    },
    // 表格当前记录改变
    handleTableCurrentChange(currentRow, oldCurrentRow) {
      if (currentRow == null) {
        return
      }
      this.cardCurrentItem = currentRow
    },
    // 查看数据节点信息
    handleDataNodeView(item) {
      if (item) {
        this.cardCurrentItem = item // 选中当前项
        this.showDataNodeModalOpen = true
      }
    },
    // 数据节点信息取消提交
    handleShowDataNodeModalCancel() {
      this.showDataNodeModalOpen = false
    },
    // 实时事件
    // 查询按钮操作
    handleRealEventFormQuery() {
      this.realEventTableQueryParams.pageNum = 1
      this.realEventTableQueryParams.lastEventId = 0 // 最后获取事件id清零，否则如无新记录则不执行查询
      this.getRealEventList()
    },
    // 重置按钮操作
    resetRealEventQueryForm() {
      this.realEventTableQueryParams.regionId = 0
      this.realEventTableQueryParams.nodeId = 0
      this.realEventTableQueryParams.descendantRegionRequired = 1
      this.realEventTableQueryParams.resourceKind = 22
      this.realEventTableQueryParams.gaugedObjectKind = 50 // 道闸
      // this.realEventTableQueryParams.systemKind = this.systemKind
      this.realEventTableQueryParams.alarmStates = []
      this.realEventDates = getTodayBeginAndEndDate() // 今天
      this.realEventTableQueryParams.beginHappenDateTime = 0
      this.realEventTableQueryParams.endHappenDateTime = 0
      this.realEventTableQueryParams.handleStates = []
      this.realEventTableQueryParams.pageNum = 1
      this.$refs['realEventQueryForm'].resetFields()
      this.handleRealEventFormQuery()
    },
    // 分页
    handleRealEventCurrentPageChange(val) {
      this.realEventTableQueryParams.pageNum = val
      this.realEventTableQueryParams.lastEventId = 0 // 最后获取事件id清零，否则如无新记录则不执行查询
      this.getRealEventList()
    },
    // 页面条数改变
    handleRealEventPageSizeChange(val) {
      this.realEventTableQueryParams.pageSize = val
      this.realEventTableQueryParams.lastEventId = 0 // 最后获取事件id清零，否则如无新记录则不执行查询
      this.getRealEventList()
    },
    // 表格选中记录改变
    handleRealEventTableSelectionChange(selection) {
      this.realEventTableSelectedIds = selection.map(item => item.id)
    },
    // 表格当前记录改变
    handleRealEventTableCurrentChange(currentRow, oldCurrentRow) {
      if (currentRow == null) {
        return
      }
      this.realEventTableCurrentRow = currentRow
    },
    // 查看事件
    handleRealEventView(row) {
      if (row && row.id) {
        this.$refs.realEventTable.setCurrentRow(row) // 选中当前行
        this.showRealEventModalOpen = true
      }
    },
    // 处理显示告警事件弹窗提交
    handleShowRealEventModalSubmit() {
      this.showRealEventModalOpen = false
      this.realEventTableCurrentRow.handled = 1
    },
    // 处理显示告警事件取消提交
    handleShowRealEventModalCancel() {
      this.showRealEventModalOpen = false
    },
    // 处理道闸控制
    handleBgControl() {
      if (this.cardCurrentItem == null) {
        this.$messagebox.confirm('请先选中一条记录！', '提示', {
          confirmButtonText: '知道了',
          showCancelButton: false,
          type: 'warning'
        })
        return
      }

      let queryText = '您确定打开【' + this.cardCurrentItem.name + '】吗?'
      this.$messagebox.confirm(queryText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let controlParams = {
          nodeId: this.cardCurrentItem.id,
          controlCmd: 1
        }
        this.$http(this.$api.doControl, controlParams).then(
          res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
            }
          }
        )
      })
    },
    // 历史事件页面------------------------------------------------------------------------------------------------
    // 查询按钮操作
    handleHistoryEventFormQuery() {
      this.historyEventTableQueryParams.pageNum = 1
      this.getHistoryEventList()
    },
    // 重置按钮操作
    resetHistoryEventQueryForm() {
      this.historyEventTableQueryParams.regionId = 0
      this.historyEventTableQueryParams.objectId = 0
      this.historyEventTableQueryParams.descendantRegionRequired = 1
      this.historyEventTableQueryParams.resourceKind = 22
      this.historyEventTableQueryParams.resourceSubType = 50 // 道闸
      // this.realEventTableQueryParams.systemKind = this.systemKind
      this.historyEventTableQueryParams.alarmStates = []
      this.historyEventDates = getOneWeekBeginAndEndDate() // 近一周
      this.historyEventTableQueryParams.beginHappenDateTime = 0
      this.historyEventTableQueryParams.endHappenDateTime = 0
      this.historyEventTableQueryParams.handleStates = []
      this.historyEventTableQueryParams.pageNum = 1
      this.$refs['historyEventQueryForm'].resetFields()
      this.handleHistoryEventFormQuery()
    },
    // 分页
    handleHistoryEventCurrentPageChange(val) {
      this.historyEventTableQueryParams.pageNum = val
      this.getHistoryEventList()
    },
    // 页面条数改变
    handleHistoryEventPageSizeChange(val) {
      this.historyEventTableQueryParams.pageSize = val
      this.getHistoryEventList()
    },
    // 表格选中记录改变
    handleHistoryEventTableSelectionChange(selection) {
      this.historyEventTableSelectedIds = selection.map(item => item.id)
    },
    // 表格当前记录改变
    handleHistoryEventTableCurrentChange(currentRow, oldCurrentRow) {
      if (currentRow == null) {
        return
      }
      this.historyEventTableCurrentRow = currentRow
    },
    // 查看事件
    handleHistoryEventView(row) {
      if (row && row.id) {
        this.$refs.historyEventTable.setCurrentRow(row) // 选中当前行
        this.showHistoryEventModalOpen = true
      }
    },
    // 处理事件
    handleHistoryEventHandle(row) {
      if (row && row.id) {
        this.$refs.historyEventTable.setCurrentRow(row) // 选中当前行
        this.handelHistoryAlarmEventModalOpen = true
      } else if (this.historyEventTableSelectedIds.length > 0) {
        this.$messagebox.confirm('您确定批量确认选中的' + this.historyEventTableSelectedIds.length + '条记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http(this.$api.confirmAlarm, {
            eventIds: this.historyEventTableSelectedIds,
            handleIdea: ''
          }).then(res => {
            if (res.code === 200) {
              this.getHistoryEventList()
              this.$message({
                type: 'success',
                message: '提交成功!'
              })
            } else {
              this.$message({
                type: 'error',
                message: '提交失败!'
              })
            }
          })
        })
      }
    },
    // 处理显示告警事件弹窗提交
    handleShowHistoryEventModalSubmit() {
      this.showHistoryEventModalOpen = false
      this.historyEventTableCurrentRow.handled = 1
    },
    // 显示告警事件信息取消提交
    handleShowHistoryEventModalCancel() {
      this.showHistoryEventModalOpen = false
    },
    // 处理告警事件弹窗提交
    handleHandleHistoryAlarmEventModalSubmit() {
      this.handelHistoryAlarmEventModalOpen = false
      this.historyEventTableCurrentRow.handled = 1
    },
    // 处理告警事件弹窗取消提交
    handleHandleHistoryAlarmEventModalCancel() {
      this.handelHistoryAlarmEventModalOpen = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/monitoring/parkingManagement/ParkingManagement.js